import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ez-table-error-state__content" }
const _hoisted_2 = { class: "ez-table-error-state__message" }

import { computed } from 'vue';
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';

interface Props {
  /** エラーメッセージ */
  errorMessage?: string;
  /** 再試行ボタンを表示するか */
  showRetryButton?: boolean;
  /** カスタムCSSクラス（省略可） */
  customClass?: string;
}

/**
 * Events定義
 */
interface Emits {
  /** 再試行ボタンクリック時 */
  retry: [];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EzTableErrorState',
  props: {
    errorMessage: { default: '' },
    showRetryButton: { type: Boolean, default: true },
    customClass: { default: '' }
  },
  emits: ["retry"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

/**
 * EzTableのエラー状態表示コンポーネント
 * テーブルのデータ取得エラーなどを表示し、再試行機能を提供する
 */

/**
 * Props定義
 */
const props = __props;

const emits = __emit;

/**
 * 再試行ボタンクリックハンドラ
 */
const handleRetry = () => {
  emits('retry');
};

/**
 * 表示するエラーメッセージを取得
 */
const displayErrorMessage = computed(() => {
  return props.errorMessage || t('データの取得に失敗しました。再度お試しください。');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ez-table-error-state', _ctx.customClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ez-table-error-state__icon" }, [
        _createElementVNode("svg", {
          width: "48",
          height: "48",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "9",
            stroke: "#e53935",
            "stroke-width": "2"
          }),
          _createElementVNode("path", {
            d: "M15 9l-6 6M9 9l6 6",
            stroke: "#e53935",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(displayErrorMessage.value), 1),
      (_ctx.showRetryButton)
        ? (_openBlock(), _createBlock(TextButton, {
            key: 0,
            class: "ez-table-error-state__retry-button",
            "button-style": "btn-primary",
            "on-click": handleRetry
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('再取得')), 1)
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})